import { css } from '@emotion/react'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const contentContainer = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #000000;
  
  /* Only show on mobile/tablet */
  ${MQ.NOT_PHONES} {
    display: none;
  }
`

export const content = css`
  flex: 1;
  padding-top: 140px; /* Account for fixed header height */
  padding-bottom: 100px; /* Account for fixed bottom navigation */
  background-color: #000000;
`

export const tabContent = css`
  padding: ${spacing(0)};
  background-color: #000000;
  min-height: calc(100vh - 240px); /* Full height minus header and footer */
`

export const placeholderContent = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(8)};
  text-align: center;
`

export const placeholderText = css`
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  margin: 0;
` 